import styled from 'styled-components';
import sizes from 'styles/sizes';
import { BrandCode } from 'types';
import { Theme } from 'contexts/Theme';
import { PortListVariant } from './CruiseCardLocationList.types';


export const CruiseCardLocationListBase = styled.div`
  display: inline;
  max-width: ${sizes.media.tabletMinWidth}px;

  ${({ theme, variant }: { theme: Theme, variant: PortListVariant}) => ({
    [BrandCode.Celebrity]: `
      color: ${theme.palette.text.secondary};
      font-size: 12px;
      letter-spacing: 0.48px;
      line-height: 18px;

      ${variant === PortListVariant.CruiseCard ? `
        @media (min-width: ${sizes.media.tabletLandscape}px) {
          font-size: 14px;
          letter-spacing: 0.56px;
          line-height: 21px;
        }
      ` : ''}

      ${variant === PortListVariant.PricingPanel ? `
        line-height: 24px;
        letter-spacing: 0.24px;
        
        @media (min-width: ${sizes.media.tabletMinWidth}px) {
          font-size: 14px;
          letter-spacing: 0.28px;
        }
      ` : ''}
    `,
    [BrandCode.RoyalCaribbean]: `
      color: ${theme.palette.grey[800]};
      font-size: 14px;
      letter-spacing: -0.28px;
      line-height: 17px;

      ${variant === PortListVariant.CruiseCard ? `
        @media (min-width: ${sizes.media.tabletPortrait}px) {
          font-size: 16px;
          letter-spacing: -0.32px;
          line-height: 19px;
        }

        @media (min-width: ${sizes.media.tabletLandscape}px) {
          font-size: 14px;
          letter-spacing: -0.28px;
          line-height: 17px;
        }

        @media (min-width: ${sizes.media.mediumMaxWidth}px) {
          font-size: 16px;
          letter-spacing: -0.32px;
          line-height: 19px;
        }
      ` : ''}

      ${variant === PortListVariant.PricingPanel ? `
        line-height: 24px;

        @media (min-width: ${sizes.media.tabletMinWidth}px) {
          font-size: 16px;
          letter-spacing: -0.32px;

        }
      ` : ''}
    `,
  }[theme.brandCode])}
`;

export const CruiseCardLocationListTitle = styled.span`
  font-family: ${({ theme }) => theme.typography.fontFamilySemiBold};
  margin-right: 5px;
  text-transform: uppercase;
`;

export const CruiseCardLocationListItemsContainer = styled.ul`
  display: inline;
`;

export const CruiseCardLocationListItem = styled.li`
  display: inline;

  &:not(:last-child)::after {
    content: "•";
    margin-left: 5px;
    margin-right: 5px;
    padding: 0px;
  }
`;